import { autobind } from 'core-decorators'
import { inject } from 'mobx-react'
import * as React from 'react'
import { Jaw } from '../../../../../shared/Constants'
import { breakpoint, styled } from '../../../../../shared/styled-components'
import { Utils } from '../../../../../shared/Utils'
import { CalculatorStoreInstance } from '../../../../../stores/CalculatorStore'
import { TEETH_INDICES } from '../../../../Constants'

interface IProps {
  jaw: Jaw
  store?: CalculatorStoreInstance
}

@inject('store')
export class JawToothSelection extends React.Component<IProps> {
  private _containerRef: React.RefObject<HTMLDivElement> = React.createRef()

  // -------------------------------------------------------------------------- LIFECYCLE

  async componentDidMount () {
    const { jaw } = this.props
    const response = await fetch(Utils.getAssetPath(`/assets/calculator/${jaw}_jaw.svg`))
    const svg = await response.text()
    const container = this._containerRef.current!
    if (container) {
      container.insertAdjacentHTML('afterbegin', svg)

      TEETH_INDICES[jaw].forEach(toothIndex => {
        const tooth: SVGPathElement = container.querySelector(`#tooth${toothIndex}-selected`)
        tooth.addEventListener('click', this._onToothClick)
        tooth.addEventListener('touchstart', this._onToothClick)
      })
      this._updateSelectedTeeth()
    } else {
      throw new Error('No container to append jaw image to')
    }
  }

  componentWillUnmount (): void {
    const { jaw } = this.props
    const container = this._containerRef.current!
    TEETH_INDICES[jaw].forEach(toothIndex => {
      const tooth = container.querySelector(`#tooth${toothIndex}-selected`)
      if (tooth) {
        tooth.removeEventListener('click', this._onToothClick)
        tooth.removeEventListener('touchstart', this._onToothClick)
      }
    })
  }

  // -------------------------------------------------------------------------- HELPERS

  private _updateSelectedTeeth () {
    const { store, jaw } = this.props
    const requirement = store!.offer[`${jaw}JawRequirement`]
    const container = this._containerRef.current!

    TEETH_INDICES[jaw].forEach(toothIndex => {
      const tooth = container.querySelector(`#tooth${toothIndex}-selected`)
      if (requirement.isToothMissing(toothIndex)) {
        tooth.classList.add('selected')
      } else {
        tooth.classList.remove('selected')
      }
    })
  }

  // -------------------------------------------------------------------------- EVENTS

  @autobind
  private _onToothClick (e: MouseEvent) {
    if (e.cancelable) {
      e.preventDefault()
    }

    const { store, jaw } = this.props
    const requirement = store!.offer[`${jaw}JawRequirement`]

    console.log(jaw)

    const id = (e.target as HTMLDivElement).id
    const match = id.match(/^tooth([0-9+]+)/)
    if (match) {
      const index = parseInt(match[1], 10)
      requirement.toggleToothMissing(index)
    }
    this._updateSelectedTeeth()
  }

  // -------------------------------------------------------------------------- RENDERING

  render () {
    return (<Container ref={this._containerRef} />)
  }
}


const selectors = [].concat(TEETH_INDICES.lower).concat(TEETH_INDICES.upper)
  .map(i => `svg #tooth${i}-selected`)

const Container = styled.div`
  ${selectors.join(', ')} {
    opacity: 0;
    cursor: pointer;
    transition: all 0.1s ease-out;
    fill: ${props => props.theme.primaryColor};
  }
  ${breakpoint('tablet')`
    ${selectors.map(s => `${s}:hover`).join(', ')} {
      opacity: 1;
      stroke: ${props => props.theme.primaryColor};
      stroke-width:10px;
      stroke-linejoin: round;
      z-index: 2;
      fill: ${props => props.theme.primaryColor};
    } 
  `}
  ${selectors.map(s => `${s}.selected`).join(', ')} {
    opacity: 1;
    fill: ${props => props.theme.primaryColor};
  }

  
`
